// extracted by mini-css-extract-plugin
module.exports = {"highlight":"styles-module__highlight___2CHsV"};